import { render, staticRenderFns } from "./StudyMain.vue?vue&type=template&id=309c8fa1&"
import script from "./StudyMain.vue?vue&type=script&lang=js&"
export * from "./StudyMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports